import React, {Component} from 'react';
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { renderField, renderCheckbox, required, renderTextArea, json } from "../../../utils/formValidations.js";
import { withRouter } from "react-router-dom";
import { Form, FormGroup, Button, Label, Row, Col, CardBody, CardFooter, Collapse, Alert } from "reactstrap";
import Proptypes from "prop-types";
import { NotificationManager } from "react-notifications";
import {getBrandingConfigs } from "../../../actions/actionBranding";
import { getLicenseStatus} from "../../../actions/actionFooter";

class BrandingConfigFormTemplate extends Component {
    constructor (props){
        super(props);
        this.state = {
            currentBranding: {},
            collapseAdvanced: false,
            licensed: false,
        };
        this.submitApi = this.submitApi.bind(this);
        this.handleCreateSuccess = this.handleCreateSuccess.bind(this);
        this.handleCreateError = this.handleCreateError.bind(this);
        this.handleUpdateError = this.handleUpdateError.bind(this);
        this.handleUpdateSuccess = this.handleUpdateSuccess.bind(this);
    }

    submitApi(userData) {
        if (!userData.categories){
            userData.categories = {};
        }
        if (this.props.fromUpdate) {
            userData.branding_config_id = this.state.currentBranding && this.state.currentBranding.branding_config_id;
            this.props.updateBrandingConfig(userData)
                .then(() => this.handleUpdateSuccess())
                .catch(() => this.handleUpdateError());
        }else {
            this.props.createBrandingConfig(userData)
                .then(() => this.handleCreateSuccess())
                .catch(() => this.handleCreateError());
        }
    }

    handleUpdateSuccess(){
        const {updateBrandingError} = this.props;
        if(updateBrandingError){
            NotificationManager.error(updateBrandingError,"Update Branding Config", 3000);
        }
        else{
            NotificationManager.success("Branding Config Updated", "Successfully Updated Branding Config");
            this.props.history.push("/branding");
        }
    }

    handleUpdateError(){
        const {updateBrandingError} = this.props;
        if(updateBrandingError){
            NotificationManager.error(updateBrandingError,"Update Branding Config", 3000);
        } else
            NotificationManager.error("Update Branding Config Failed", "Update Branding Config", 3000);
    }

    handleCreateSuccess(){
        const {createBrandingError} = this.props;
        if(createBrandingError){
            NotificationManager.error(createBrandingError,"Create Branding Config", 3000);
        }
        else{
            NotificationManager.success("Branding Config Created", "Successfully Created Branding Config");
            this.props.history.push("/branding");
        }
    }

    handleCreateError(){
        const {createBrandingError} = this.props;
        if(createBrandingError){
            NotificationManager.error(createBrandingError,"Create Branding Config", 3000);
        } else
            NotificationManager.error("Create Branding Config Failed","Create Branding Config", 3000);
    }

    cancelButton(){
        this.props.history.push("/branding");
    }


    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.branding_configs && nextProps.branding_configs.length > 0 && this.props.branding_configs !== nextProps.branding_configs && this.props.getBrandingLoading && this.props.fromUpdate){
            let currentBranding = nextProps.branding_configs.find(branding => branding.branding_config_id === this.props.brandingConfigId);
            this.setState({currentBranding: currentBranding});
            this.props.initialize({
                name: currentBranding.name,
                hostname: currentBranding.hostname,
                favicon_logo_url: currentBranding.favicon_logo_url,
                header_logo_url: currentBranding.header_logo_url,
                login_splash_url: currentBranding.login_splash_url,
                splash_url: currentBranding.splash_url,
                html_title: currentBranding.html_title,
                login_caption: currentBranding.login_caption,
                login_logo_url: currentBranding.login_logo_url,
                loading_session_text: currentBranding.loading_session_text,
                joining_session_text: currentBranding.joining_session_text,
                destroying_session_text: currentBranding.destroying_session_text,
                is_default: currentBranding.is_default,


            });
        }
    }

    componentDidMount() {
        if (this.props.fromUpdate) {
            this.props.getBrandingConfigs();
        }
        this.props.getLicenseStatus()
            .then(() => {
                const {license_info} = this.props;
                if (license_info && license_info.status && license_info.status.features && license_info.status.features.indexOf('branding') >= 0 ){
                    this.setState({licensed: true});
                }
            });
    }
    

    render() {
        const {handleSubmit} = this.props;
        const deny_by_default_checked = false;
        if (!this.state.licensed){
            let license_url = `${__LICENSE_INFO_URL__}`;
            return (
                <Alert color="none" isOpen={true}>
                    <h4>Unavailable</h4>
                    This feature must be licensed.
                    <hr />
                    <a href={license_url}>More Information</a><br/>
                </Alert>
            )
        }
        return (
            <Form onSubmit={handleSubmit(this.submitApi)}>
                <CardBody>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="name" className="requiredasterisk">Name </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="name"
                                       id="name"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="hostname" className="requiredasterisk">Hostname </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="hostname"
                                       id="hostname"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="favicon_logo_url" className="requiredasterisk">Favicon Logo URL </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="favicon_logo_url"
                                       id="favicon_logo_url"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="header_logo_url" className="requiredasterisk">Header Logo URL </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="header_logo_url"
                                       id="header_logo_url"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="6">
                                <Label htmlFor="splash_url" className="requiredasterisk">Splash Background URL </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="splash_url"
                                       id="splash_url"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="html_title" className="requiredasterisk">HTML Title </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="html_title"
                                       id="html_title"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="login_caption" className="requiredasterisk">Login Caption </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="login_caption"
                                       id="login_caption"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="login_logo_url" className="requiredasterisk">Login Logo URL </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="login_logo_url"
                                       id="login_logo_url"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="6">
                                <Label htmlFor="splash_url" className="requiredasterisk">Login Splash Background URL </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="login_splash_url"
                                       id="login_splash_url"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="loading_session_text" className="requiredasterisk">Loading Session Text </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="loading_session_text"
                                       id="loading_session_text"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="joining_session_text" className="requiredasterisk">Joining Session Text </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="joining_session_text"
                                       id="joining_session_text"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="6">
                                <Label htmlFor="destroying_session_text" className="requiredasterisk">Deleting Session Text </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="destroying_session_text"
                                       id="destroying_session_text"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="is_default">Default </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="checkbox"
                                       name="is_default"
                                       id="is_default"
                                       checked = {deny_by_default_checked}
                                       component={renderCheckbox}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                </CardBody>
                <CardFooter>
                    <FormGroup className="form-actions">
                        <Button type="cancel" size="sm" 
                        className="cancel-button"
                        color="basic" onClick={() => this.cancelButton()}>Cancel</Button>
                        <Button type="submit"
                        className="submit-button"
                        size="sm" color="primary">Submit</Button>
                    </FormGroup>
                </CardFooter>
            </Form>
        );
    }
}

BrandingConfigFormTemplate.proptypes = {
    createBrandingConfig: Proptypes.func,
    updateBrandingConfig: Proptypes.func,
    fromUpdate: Proptypes.bool,
};

let BrandingConfigFormWithRouter = withRouter(BrandingConfigFormTemplate);


const selector = formValueSelector('BrandingConfigForm');

let BrandingConfigForm =  connect(state =>{

            const has_categorization_enabled = selector(state, 'enable_categorization');

            return {
                has_categorization_enabled,
                createBrandingError: state.branding.createBrandingError,
                createBrandingLoading: state.branding.createBrandingLoading,
                createdBranding: state.branding.createdBranding,
                updateBrandingError: state.branding.updateBrandingError,
                updateBrandingLoading: state.branding.updateBrandingLoading,
                updatedBranding: state.branding.updatedBranding,
                branding_configs: state.branding.branding_configs,
                getBrandingLoading: state.branding.getBrandingLoading || false,
                license_info: state.footer && state.footer.license_info ? state.footer.license_info : null,
            }
    },

    dispatch =>
        ({
            getBrandingConfigs: () => dispatch(getBrandingConfigs()),
            getLicenseStatus: () => dispatch(getLicenseStatus()),
        }))(BrandingConfigFormWithRouter);

export default reduxForm({
    form: "BrandingConfigForm",
})(BrandingConfigForm);


// WEBPACK FOOTER //
// ./src/views/Branding/BrandingConfigForm/BrandingConfigForm.js